<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import FileSaver from 'file-saver';
import axios from 'axios';
import snackbarMixin from '@/mixins/snackbar';
import paginationMixin from '@/mixins/pagination';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'RbxFileList',
  components: {
    RbxConfirmDialog,
  },
  mixins: [snackbarMixin, paginationMixin],
  props: {
    fileList: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fileListHeaders: [
        { text: 'Erstellt am', value: 'dateCreated' },
        { text: 'Bezeichnung', value: 'name' },
        { text: 'Erstellt von', value: 'createdBy' },
        { text: 'Aktionen', value: '' },
      ],
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      itemToDelete: {},
      pagination: {
        sortBy: 'dateCreated',
        descending: true,
      },
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    download(item) {
      return axios.get(item.url, { responseType: 'blob' })
        .then(({ data }) => {
          FileSaver.saveAs(data, item.name);
        })
        .catch(() => {
          this.showErrorMessage('Die Datei konnte nicht heruntergeladen werden.');
        });
    },
    onDelete(itemToDelete) {
      this.itemToDelete = itemToDelete;
      this.confirmDeletionMessage = `Soll die Datei ${this.itemToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      axios.delete(`/ufile/${this.itemToDelete.id}`)
        .then(() => {
          this.showSuccessMessage('Die Datei wurde gelöscht.');
          this.isConfirmDialogDisplayed = false;
          this.$emit('remove', this.itemToDelete);
        })
        .catch(() => {
          this.showErrorMessage('Die Datei konnte nicht gelöscht werden.');
        });
    },
    formatCreatedDate(value) {
      return value ? moment(value).format('DD.MM.YYYY') : '';
    },
  },
};
</script>

<template>
  <div class="rbx-file-list">
    <v-data-table
      :headers="fileListHeaders"
      :items="fileList"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      no-data-text="keine Daten verfügbar"
      rows-per-page-text="Zeilen pro Seite"
      :rows-per-page-items="rowsPerPageItems"
    >
      <template slot="pageText" scope="{ pageStart, pageStop }">
        von {{ pageStart }} bis {{ pageStop }}
      </template>

      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{ formatCreatedDate(props.item.dateCreated) }}
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.createdBy }}
          </td>
          <td>
            <v-btn v-if="auth.hasDownloadRights" small flat fab @click="download(props.item)">
              <v-icon>cloud_download</v-icon>
            </v-btn>

            <v-btn
              v-if="!readonly && auth.hasDeleteRights"
              small flat fab
              @click="onDelete(props.item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <rbx-confirm-dialog
      @confirm="onConfirm" @refuse="onRefuse"
      :message="confirmDeletionMessage"
      :is-displayed="isConfirmDialogDisplayed"
    />
  </div>
</template>

<style lang="scss">
.rbx-file-list {
  img {
    max-height: 100%;
    display: block;
    margin-top: 3px;
  }
}
</style>
